import React, { FC } from 'react';
import { PageProps, graphql } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';

import View from '../views/Home';
import flattenMessages from '../helpers/flattenMessages';
import Layout from '../components/Layout/Layout';

export interface DataType {
  file: {
    childJson: {
      content: {
        title: string;
        subtitle: string;
        button_text: string;
        button_link: string;
        image: {
          childImageSharp: {
            gatsbyImageData: IGatsbyImageData;
          };
        };
      };
    };
  };
}

interface ContextType {
  locale: string;
  name: string;
}

const Page: FC<PageProps<DataType, ContextType>> = props => {
  const {
    pageContext: { locale },
    data,
  } = props;
  const messages = flattenMessages(data.file.childJson, 'home');

  return (
    <Layout locale={locale} messages={messages}>
      <View data={data} />
    </Layout>
  );
};

export { default as Head } from '../components/Head';

export const query = graphql`
  query HomeQuery($name: String!) {
    file(relativeDirectory: { eq: "home" }, name: { eq: $name }) {
      childJson {
        ...HeroSection
        ...FreeCrypto
        ...Rewards
        ...SpendRewards
        ...Earn
        ...Verse
        ...Play
        ...Learn
        ...FAQ
        ...Advertise
        ...ReadytoGetStarted
        ...Meta
      }
    }
  }
`;

export default Page;
